import React from "react";

import { useOnboardingContentManager } from "./hooks/useOnboardingContentManager";

export function withOnboardingContentManager(Component) {
  return (props) => {
    const { shouldShowOnboardingContent, updateHubClickCount } =
      useOnboardingContentManager();

    return (
      <Component
        {...props}
        shouldShowOnboardingContent={shouldShowOnboardingContent}
        updateHubClickCount={updateHubClickCount}
      />
    );
  };
}

export default withOnboardingContentManager;
